<div class="issue-card p-3 mb-3">
  <div>
    <!-- Status stays top aligned so it holds its place however long the title wraps. -->
    <div class="flex justify-content-between align-items-start gap-3">
      <div class="flex align-items-center gap-2 mb-1">
        <h4 class="mt-0 mb-0">{{ issue.title }}</h4>
        <!-- Which movement the issue is against, since a booking can hold several. -->
        <vehicle-reg *ngIf="task?.vehicleReg">{{ task.vehicleReg }}</vehicle-reg>
      </div>
      <pill
        class="flex-shrink-0"
        [backgroundColour]="statusColours.background"
        [textColour]="statusColours.text"
      >
        <span class="white-space-nowrap">{{ statusLabel }}</span>
      </pill>
    </div>
    <p class="mb-0 text-gray-600">{{ issue.description }}</p>
  </div>

  <div class="flex justify-content-between align-items-start mt-3" *ngIf="details.length > 0">
    <table class="issue-details">
      <tr *ngFor="let detail of details">
        <td class="text-gray-600 pr-4 align-top">{{ detail.label }}:</td>
        <td class="bold-text">{{ detail.value }}</td>
      </tr>
    </table>
    <!-- The booking detail stays visible on a closed issue for context, but there is nothing left
         to correct, so the action is only offered while it is open. -->
    <button
      *ngIf="issue.status === OrderBookingIssueStatus.Open"
      pButton
      type="button"
      label="Open Job"
      class="ui-button-secondary flex-shrink-0"
      (click)="openJobScreen()"
    ></button>
  </div>

  <div
    class="issue-action mt-3 p-2 border-round"
    *ngIf="issue.status === OrderBookingIssueStatus.Open"
  >
    <i class="fa fa-info-circle mr-2"></i>{{ issue.resolvingActions }}
  </div>

  <div
    class="issue-dismissal mt-3 p-2 border-round"
    *ngIf="issue.status === OrderBookingIssueStatus.Dismissed"
  >
    <i class="fa fa-exclamation-circle mr-2"></i>{{ issue.dismissalReason }}
    <span class="text-gray-600">
      by {{ issue.dismissedByName }}, {{ issue.dateDismissed | datex : 'DD MMM YYYY HH:mm' }}
    </span>
  </div>

  <!-- No manual "resolve": an issue clears itself once the booking stops failing the check.
       Dismiss is for the case where the booking is fine as it stands. -->
  <div class="flex gap-2 mt-3" *ngIf="issue.status === OrderBookingIssueStatus.Open">
    <button
      pButton
      type="button"
      label="Dismiss"
      class="ui-button-secondary"
      [disabled]="saving"
      (click)="openDismissDialog()"
    ></button>
  </div>
</div>

<p-dialog
  header="Dismiss issue"
  [(visible)]="showDismissDialog"
  [modal]="true"
  [style]="{ width: '480px' }"
>
  <p>
    Dismissing records that this issue was reviewed and needs no correction. Please say why, so
    recurring false positives can be found and fixed.
  </p>
  <textarea
    pInputTextarea
    class="w-full"
    rows="4"
    maxlength="500"
    [(ngModel)]="dismissalReason"
    placeholder="Reason for dismissal"
  ></textarea>
  <p-footer>
    <button
      pButton
      type="button"
      label="Cancel"
      class="ui-button-secondary"
      (click)="showDismissDialog = false"
    ></button>
    <button
      pButton
      type="button"
      label="Dismiss issue"
      [disabled]="saving || !dismissalReason?.trim()"
      (click)="confirmDismiss()"
    ></button>
  </p-footer>
</p-dialog>
